export const menuItems = [
  { label: 'DEVICES', path: '/devices', key: 'devices' },
  { label: 'WALKDOWNS', path: '/walkdowns', key: 'walkdowns' },
  { label: 'SITE DOCUMENTATION', path: '/site-documentation', key: 'site-documentation' },
  { label: 'LOCATIONS', path: '/locations', key: 'locations' },
  { label: 'TURNAROUNDS', path: '/turnarounds', key: 'turnarounds' },
  // { label: 'SYSTEMS & SOFTWARE', path: '/systems-software', key: 'systems-software' },
  { label: 'VALVE CONDITION MONITORING', path: '/valve-condition-monitoring', key: 'valve-condition-monitoring' },
];

export const HeaderItems = [
  { label: 'PRODUCTS', path: '/products', key: 'products' },
  { label: 'SOFTWARE', path: '/software', key: 'software' },
  { label: 'INDUSTRIES', path: '/industries', key: 'industries' },
  { label: 'COMPANY', path: '/company', key: 'company' },
];

// Map of all routes (including internal) to their parent menu key
const routeToMenuKey: Record<string, string> = {
  '/': 'devices',
  '/devices': 'devices',
  '/devices/:id': 'devices', // device details
  '/devices/:id/documents': 'devices', // documents under device details
  '/login': 'login',
  '/logout': 'logout',
  '/walkdowns': 'walkdowns',
  '/walkdowns/:id': 'walkdowns', // walkdown details
  '/walkdowns/:id/documents': 'walkdowns', // documents under walkdown details
  '/turnarounds': 'turnarounds',
  '/turnarounds/:id': 'turnarounds', // turnaround details
  '/turnarounds/:id/documents': 'turnarounds', // documents under turnaround details
  '/site-docs': 'site-docs',
  '/site-docs/:id': 'site-docs', // site documentation details
  '/site-docs/:id/documents': 'site-docs', // documents under site documentation details
  '/systems-software': 'systems-software',
  '/systems-software/:id': 'systems-software', // system/software details
  '/systems-software/:id/documents': 'systems-software', // documents under system/software details
  '/valve-condition-monitoring': 'valve-condition-monitoring',
  '/valve-condition-monitoring/:id': 'valve-condition-monitoring', // valve condition monitoring details
  '/valve-condition-monitoring/:id/documents': 'valve-condition-monitoring', // documents under valve condition monitoring details
  // Add more mappings as needed
};

// Helper to match dynamic routes (e.g., /devicelist/123, /devicelist/123/documents)
function matchRoute(pathname: string): string | undefined {
  for (const route in routeToMenuKey) {
    // Convert route pattern to regex
    const pattern = route.replace(/:[^/]+/g, '[^/]+');
    const regex = new RegExp(`^${pattern}$`);
    if (regex.test(pathname)) {
      return routeToMenuKey[route];
    }
  }
  return undefined;
}

export function getActiveMenuKey(pathname: string): string | undefined {
  // Try to match exact
  if (routeToMenuKey[pathname]) return routeToMenuKey[pathname];
  // Try to match dynamic/internal routes
  return matchRoute(pathname);
}
